import styles from "./InputField.module.scss";

const UrlField = ({
  name,
  label,
  watch,
  register,
  validation,
  errors,
  required = false,
  placeholder = "",
  isStatic = false,
  readOnly = false,
}) => {
  return (
    <div className={styles.field__textArea}>
      <label className={`form-label ${styles.field__label}`}>
        {label}
        <span className={styles.field__label__required}>
          {required && !isStatic ? "必須" : ""}
        </span>
      </label>

      {isStatic ? (
        watch(name) ? (
          <a
            href={watch(name)}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles.field__input} ${
              errors[name] ? "is-invalid" : ""
            } `}
          >
            {watch(name)}
          </a>
        ) : (
          <></>
        )
      ) : (
        <input
          type={"text"}
          className={`${styles.field__input} ${
            errors[name] ? "is-invalid" : ""
          } ${"form-control"}`}
          placeholder={placeholder}
          {...register(name, {
            ...validation,
          })}
          readOnly={isStatic || readOnly}
        />
      )}

      <p className={`invalid-feedback ${styles.field__msg}`}>
        {errors[name] ? errors[name].message : ""}
      </p>
    </div>
  );
};

export default UrlField;
